import {saveState} from '@web/actions/restoreState'
import {VERSION} from '@web/core/config'
import sessionSyncCreator from '@web/middlewares/sessionSync'

import {CheckoutRootState as RootState} from '../../../interfaces'

export type SyncState = RootState

/**
 * 세선 스토리지에 싱크를 맞춰야하는 엑션들의 type 값들 모음
 */
const sessionSyncActions = [saveState.type]

const createSessionKey = (state: RootState) => {
    const {
        common: {seqID},
    } = state

    return seqID ?? ''
}

const sessionSync = sessionSyncCreator<RootState>({
    actionWithSessions: sessionSyncActions,
    createKey: (state) => [createSessionKey(state), VERSION],
    createSessionKey,
})

export default sessionSync
